import type { AxiosError } from 'axios'

interface ISpencerError { code: number; message: string }

class ErrorService {
  getErrorMessage (error: AxiosError<Pick<ISpencerError, 'code'>>) {
    return this.hashedCodes[error?.response?.data?.code || '']?.message
  }

  codes = {
    SESSION_EXPIRED: { code: 10001, title: 'Session expired', message: 'Please login back in your account.' },
    IMPERSONATION_EXPIRED: { code: 10002, title: 'Impersonation Ended', message: 'Session expired. Please start impersonation again.' },
    RATE_LIMIT_EXCEEDED: { code: 10003, title: 'Rate limit exceeded', message: 'You have made too many requests. Please wait a moment and try again.' },

    DEFAULT: { code: 1000, message: 'Something went wrong. Please, refresh the page or try again later.' },
    SCHOOL_UNIQUE_SUBDOMAIN: { code: 1001, message: 'School subdomain should be unique. Please change it and try again.' },
    THEME_DELETE_EXISTING_REFS: { code: 1002, message: 'The theme has an existing reference. Can\'t delete' },
    STUDENT_UPN_DUP: { code: 1003, message: 'Student upn already exist.' },
    ASSIGN_KEY_PROFESSIONAL: { code: 1004, message: 'Student can have only one key professional' },
    QUESTIONNAIRE_PROFILE_EXIST: { code: 1005, message: 'This entity can’t be deleted as it has connected profiles.' },
    TRANSFER_REQUEST_ALREADY_EXIST: {
      code: 1006,
      message: 'A transfer request is already pending for this student. Only one active request is allowed.'
    },
    TOKEN_EXPIRED: { code: 1007, title: 'Token expired', message: 'The token has expired. Please request a new link to continue.' },
    RESET_PASSWORD_USER_NOT_FOUND: {
      code: 1008,
      message: 'No account found for this email address. Please check the address or sign up.'
    },
    IMPORT_STUDENTS_DIRECTORY_CSV: {
      code: 100001,
      message: 'File is broken, please make sure your CSV file has correct columns and values.'
    }
  } as const

  get hashedCodes () {
    return Object.values(this.codes).reduce((acc, currCodeMeta) => {
      return { ...acc, [currCodeMeta.code]: currCodeMeta }
    }, {} as TIndexedObject<ISpencerError>)
  }
}

export const errorService = new ErrorService()
